// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3w-_4","name":"ConsentHeader_name__wbQVq","birthday":"ConsentHeader_birthday__1rCxe","skeleton":"ConsentHeader_skeleton__1-Gyy"};